//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      info: {}
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {

  },
  computed: {
    orderAmount() {
      let v = 0
      _.each(this.info.items, (t, i, l) => {
        if (!t.isDelete) {
          v += t.buyNumber * t.price
        }
      })
      return v
    }
  },
  mounted () {

  },
  methods: {
    handleDeleteRow (row) {
      // console.log('handleDeleteRow.row', row)
      /**/
      let items = []
      let data = {orderId: this.info.orderId}
      items.push({itemId: row.data.itemId, num: row.data.buyNumber, status: 1})
      data.items = JSON.stringify(items)
      this.loading = true
      this.$axios.post('/mtea/store/admin/order/modifi', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.handleLoadData()
      }).finally(() => {
        this.loading = false
      })
    },
    handleModifyNum(row) {
      let items = []
      let data = {orderId: this.info.orderId}
      items.push({itemId: row.data.itemId, num: row.data.buyNumber, status: 0})
      data.items = JSON.stringify(items)
      this.loading = true
      this.$axios.post('/mtea/store/admin/order/modifi', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        row.state.showPopover = false
        this.handleLoadData()
      }).finally(() => {
        this.loading = false
      })
    },
    handleLoadData () {
      let data = _.pick(this.initialForm, 'orderId')
      let loading = this.$loading({lock: true})
      this.$axios.get('/mtea/store/admin/order/info', { params: data }).then(res => {
        res.items = _.filter(res.items, (item) => {
          return item.status !== 1
        })
        _.each(res.items, (t, i, l) => {
          t._buyNumber = t.buyNumber
          if (t.goodsExtra) {
            l[i].goodsExtra = JSON.parse(t.goodsExtra)
          }
        })
        res.records = _.sortBy(res.records, function(t){
          return moment(t.createTime).valueOf()
        })
        this.info = res
      }).finally(() => {
        loading.close()
      })
    },
    handleOpen () {
      this.handleLoadData()
    },
    handleClose () {
      _.extend(this, _.pick(this.$options.data(), 'info'))
      this.$emit('submit')
    },
    handleFormSubmit() {
      let items = []
      let data = {orderId: this.info.orderId}
      _.each(this.info.items, function(t){
        if (t.isDelete) {
          items.push({itemId: t.itemId, num: t.buyNumber, status: 1})
        } else if (t._buyNumber !== t.buyNumber){
          items.push({itemId: t.itemId, num: t.buyNumber, status: 0})
        }
      })
      data.items = JSON.stringify(items)
      this.loading = true
      this.$axios.post('/mtea/store/admin/order/modifi', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('update:visible', false)
        this.$emit('submit')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
